import { render } from "./SkuName.vue?vue&type=template&id=02f613db&scoped=true"
import script from "./SkuName.vue?vue&type=script&lang=js"
export * from "./SkuName.vue?vue&type=script&lang=js"

import "./SkuName.vue?vue&type=style&index=0&id=02f613db&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02f613db"]])

export default __exports__